export default __webpack_public_path__ + "static/media/spokenHero.be7b33b0.svg";